import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FiArrowUpLeft, FiArrowUpRight, FiHelpCircle } from 'react-icons/fi';
import '../../../components/HelpModal/HelpModal.css';

function FechamentoNewHelpModal() {
    const [show, setShow] = useState(false);
    const [isSteps, setIsSteps] = useState(1);

    const handleClose = () => {
        setIsSteps(1);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const getStepsView = (step) => {
        switch (step) {
            case 1: return (
                <Modal.Body >
                    <p className="description-text-info">
                        Para criar um fechamento, você deve inserir uma identificação e o período de apuração do fechamento que seria uma data de início e fim e a quantidade de dias úteis para ser calculado.
                        <br></br>
                        Se desejar, pode acrescentar uma descrição que for útil para saber mais sobre esse fechamento depois.
                    </p>
                    <div className="icon-arrow-left">
                        <FiArrowUpLeft size={25} />
                    </div>
                </Modal.Body>
            );
            case 2: return (
                <Modal.Body>
                    <p className="description-text-info">
                        Após inserir os dados, é só conferir os dados inseridos e clicar no botão salvar ou cancelar que está no canto superior direito!
                    </p>
                    <div className="icon-arrow-right">
                        <FiArrowUpRight size={25} />
                    </div>
                </Modal.Body>
            );
            default: return ""
        }
    }

    const handleNext = () => {
        if (isSteps !== 2)
            setIsSteps(isSteps + 1)
    }

    const handlePrevious = () => {
        if (isSteps !== 1)
            setIsSteps(isSteps - 1)
    }

    return (
        <>
            <button onClick={() => handleShow(true)} className="button-info">
                <FiHelpCircle size={17} />
            </button>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Como cadastrar um novo fechamento?</Modal.Title>
                </Modal.Header>

                {getStepsView(isSteps)}

                <Modal.Footer>
                    {isSteps !== 1 && (
                        <Button variant="outline-primary" onClick={handlePrevious}>
                            Voltar
                        </Button>
                    )}

                    {isSteps !== 2 && (
                        <Button variant="outline-primary" onClick={handleNext}>
                            Próximo
                        </Button>
                    )}

                    <Button variant="outline-danger" onClick={handleClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export { FechamentoNewHelpModal }
